
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getCustomAddressList } from '@/api/company';
import { UserModule } from '@/store/modules/user';
import { lAreaData } from '@/const/LAreaData';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'GroupAddress',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Array,
    default: []
  })
  selectAddress!: [];

  private addressType = true; // 自定义
  private addressSearch: any = {
    name: ''
  };

  private lAreaData: any = [];
  private defaultProps: any = {
    children: 'child',
    label: 'name',
    value: 'id'
  };
  private listLoading = false;
  private isIndeterminate: any = null;
  private addressSelectedAll = false;
  private tableDataAddress: any = [];
  private addressTags: any = [];
  private tableDataArea: any = [];
  private addressSelected: any = [];

  get addressTotal() {
    let num = this.tableDataAddress.length;
    for (let item of this.tableDataAddress) {
      num += item.child.length;
      for (let value of item.child) {
        num += value.child.length;
      }
    }
    return num;
  }

  created() {
    this.addressTags = this.selectAddress;
    if (this.addressTags && this.addressTags.length > 0) {
      for (let i = 0; i < this.addressTags.length; i++) {
        if (this.addressTags[i].province_name) {
          this.addressTags[i].address = this.addressTags[i].province_name;
        }
        if (this.addressTags[i].city_name) {
          this.addressTags[i].address = this.addressTags[i].city_name;
        }
        if (this.addressTags[i].district_name) {
          this.addressTags[i].address = this.addressTags[i].district_name;
        }
      }
    }

    this.addressType = checkPermissionCompany(
      UserModule.getCompanyId,
      Type.pca
    );
    if (this.addressType) {
      this.lAreaData = lAreaData;
      this.setSelect(this.lAreaData);
    } else {
      this.getCustomAddressList();
    }
  }

  // 搜索
  private addressSearchHandle() {
    this.getCustomAddressList();
  }
  private addressClearHandle() {
    this.addressSearch.name = '';
    this.getCustomAddressList();
  }
  private getCustomAddressList() {
    this.listLoading = true;
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      contain_sub: 1
    };
    if (this.addressSearch.name) {
      params.address = this.addressSearch.name;
    }
    getCustomAddressList(params).then((res) => {
      if (res.data && res.data.list) {
        this.tableDataAddress = res.data.list;
        this.setSelect(this.tableDataAddress);
      } else {
        this.tableDataAddress = [];
      }
    });
  }

  // 地址
  private CloseAddressHandle(index: any) {
    this.addressTags.splice(index, 1);
    this.addressSelected.splice(index, 1);
    let checkedCount = this.addressTags.length;
    if (this.addressTags) {
      this.addressSelectedAll = checkedCount === this.addressTotal;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.addressTotal;
    }

    // this.$emit('addressSelectedChange', this.addressTags);
  }
  private addressSelectedChange(
    oneData: any,
    twoData: any = '',
    thrData: any = ''
  ) {
    let fieldId = 'id';
    let fieldName = 'name';
    if (this.addressType) {
      fieldId = 'id';
      fieldName = 'name';
    } else {
      fieldId = 'id';
      fieldName = 'address';
    }

    let val: any = {};
    if (oneData) {
      val.address_id = oneData[fieldId];
      val.address = oneData[fieldName];
      val.province_id = oneData[fieldId];
      val.province_name = oneData[fieldName];
      val.city_id = 0;
      val.city_name = '';
      val.district_id = 0;
      val.district_name = '';
    }
    if (twoData) {
      val.address_id = twoData[fieldId];
      val.address = twoData[fieldName];
      val.city_id = twoData[fieldId];
      val.city_name = twoData[fieldName];
      val.district_id = 0;
      val.district_name = '';
    }
    if (thrData) {
      val.address_id = thrData[fieldId];
      val.address = thrData[fieldName];
      val.district_id = thrData[fieldId];
      val.district_name = thrData[fieldName];
    }
    if (this.addressSelected.length > this.addressTags.length) {
      this.addressTags.push(val);
    } else {
      for (let i = 0; i < this.addressTags.length; i++) {
        if (this.addressTags[i].id === val.id) {
          this.addressTags.splice(i, 1);
          break;
        }
      }
    }
    if (this.addressType) {
      let checkedCount = this.addressTags.length;
      this.addressSelectedAll = checkedCount === this.addressTotal;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.addressTotal;
    }

    this.$emit('addressSelectedChange', this.addressTags);
  }

  private checkAllAddressChange(val: boolean) {
    let addressOptions = [];
    let tagsOptions = [];
    if (val) {
      for (let item of this.tableDataAddress) {
        addressOptions.push(item);
        tagsOptions.push({
          address_id: item.id,
          address: item.address,
          province_id: item.id,
          province_name: item.address,
          city_id: 0,
          city_name: '',
          district_id: 0,
          district_name: ''
        });
        for (let value of item.child) {
          addressOptions.push(value);
          tagsOptions.push({
            address_id: value.id,
            address: value.address,
            province_id: item.id,
            province_name: item.address,
            city_id: value.id,
            city_name: value.address,
            district_id: 0,
            district_name: ''
          });
          for (let v of value.child) {
            addressOptions.push(v);
            tagsOptions.push({
              address_id: v.id,
              address: v.address,
              province_id: item.id,
              province_name: item.address,
              city_id: value.id,
              city_name: value.address,
              district_id: v.id,
              district_name: v.address
            });
          }
        }
      }
    }
    this.addressSelected = addressOptions;
    this.addressTags = tagsOptions;
    this.isIndeterminate = false;
    this.$emit('addressSelectedChange', this.addressTags);
  }
  private setSelect(list: any) {
    if (this.addressType) {
      if (this.selectAddress && this.selectAddress.length > 0) {
        for (let i = 0; i < this.selectAddress.length; i++) {
          let item: any = this.selectAddress[i];
          for (let m = 0; m < list.length; m++) {
            let element: any = list[m];
            if ((item as any).address_id === element.id) {
              let arr = this.addressSelected.filter((v: any) => {
                return v.id === (item as any).address_id;
              });
              if (!arr || arr.length < 1) {
                this.addressSelected.push(element);
              }
            }
            if (element.child && element.child.length) {
              this.setSelect(element.child);
            }
          }
        }
      }
    } else {
      if (this.selectAddress && this.selectAddress.length > 0) {
        for (let i = 0; i < this.selectAddress.length; i++) {
          let item: any = this.selectAddress[i];
          for (let m = 0; m < list.length; m++) {
            let element: any = list[m];
            if (element.id === item.address_id) {
              let arr = this.addressSelected.filter((v: any) => {
                return v.id === item.address_id;
              });
              if (!arr || arr.length < 1) {
                this.addressSelected.push(element);
              }
            }
            if (element.child && element.child.length) {
              this.setSelect(element.child);
            }
          }
        }

        let checkedCount = this.addressTags.length;
        this.addressSelectedAll = checkedCount === this.addressTotal;
        this.isIndeterminate =
          checkedCount > 0 && checkedCount < this.addressTotal;
      }
    }
  }
}
